import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import { App } from "./App";
import { AuthProvider } from "./contexts/AuthContext";
import { PageTitleProvider } from "./contexts/PageTitleContext";
import { queryClient } from "./lib/queryClient";
import "./index.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root nao encontrado em index.html");

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <PageTitleProvider>
            <App />
          </PageTitleProvider>
          <Toaster
            position="top-right"
            richColors
            closeButton
            toastOptions={{ duration: 4500 }}
          />
        </AuthProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>,
);
